module.exports = __webpack_public_path__ + "static/media/fast-forward.86bb8425.svg";